import { useState, useEffect } from 'react'
import { Link } from '@tanstack/react-router'
import { Tooltip } from './Tooltip'
import styles from './IconRail.module.scss'

import BrandIconDark from '@/assets/knowblemind-icon-nobg-dark.svg?react'
import BrandIconLight from '@/assets/knowblemind-icon-nobg-light.svg?react'
import MenuIcon from '@/assets/common/menu.svg?react'

interface IconRailProps {
  onToggleNav: () => void
  isNavOpen: boolean
}

function useIsDark() {
  const [isDark, setIsDark] = useState(
    () => document.documentElement.getAttribute('data-theme') === 'dark'
  )

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.getAttribute('data-theme') === 'dark')
    })
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] })
    return () => observer.disconnect()
  }, [])

  return isDark
}

export function IconRail({ onToggleNav, isNavOpen }: IconRailProps) {
  const isDark = useIsDark()
  const BrandIcon = isDark ? BrandIconLight : BrandIconDark

  return (
    <aside
      className={styles.iconRail}
      data-testid="icon-rail"
      aria-label="Application tools"
    >
      <Link to="/" className={styles.iconRail__brand} aria-label="Knowblemind">
        <BrandIcon />
      </Link>
      <div className={styles.iconRail__icons}>
        <Tooltip text="Navigation" position="right">
          <button
            className={styles.iconRail__button}
            onClick={onToggleNav}
            aria-label="Toggle navigation"
            aria-expanded={isNavOpen}
          >
            <MenuIcon />
          </button>
        </Tooltip>
      </div>
    </aside>
  )
}
